import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JhiAlertService } from 'ng-jhipster';

import { ICountryMySuffix } from 'src/app/shared/model/country-my-suffix.model';
import { CountryMySuffixService } from './country-my-suffix.service';
import { IRuleMySuffix } from 'src/app/shared/model/rule-my-suffix.model';
import { RuleMySuffixService } from 'src/app/entities/rule-my-suffix';
import { ISanctionedGroupMySuffix } from 'src/app/shared/model/sanctioned-group-my-suffix.model';
import { SanctionedGroupMySuffixService } from 'src/app/entities/sanctioned-group-my-suffix';
import { IUnderwriterMySuffix } from 'src/app/shared/model/underwriter-my-suffix.model';
import { UnderwriterMySuffixService } from 'src/app/entities/underwriter-my-suffix';
import { IInsuranceCompanyMySuffix } from 'src/app/shared/model/insurance-company-my-suffix.model';
import { InsuranceCompanyMySuffixService } from 'src/app/entities/insurance-company-my-suffix';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-country-my-suffix-update',
    templateUrl: './country-my-suffix-update.component.html'
})
export class CountryMySuffixUpdateComponent implements OnInit {
    private _country: ICountryMySuffix;
    isSaving: boolean;

    rules: IRuleMySuffix[];

    sanctionedgroups: ISanctionedGroupMySuffix[];

    underwriters: IUnderwriterMySuffix[];

    insurancecompanies: IInsuranceCompanyMySuffix[];

    constructor(
        private jhiAlertService: JhiAlertService,
        private countryService: CountryMySuffixService,
        private ruleService: RuleMySuffixService,
        private sanctionedGroupService: SanctionedGroupMySuffixService,
        private underwriterService: UnderwriterMySuffixService,
        private insuranceCompanyService: InsuranceCompanyMySuffixService,
        private activatedRoute: ActivatedRoute,
        private languageChangeService: LanguageChangeService
    ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.isSaving = false;
        this.activatedRoute.data.subscribe(({ country }) => {
            this.country = country;
        });
        this.ruleService.query().subscribe(
            (res: HttpResponse<IRuleMySuffix[]>) => {
                this.rules = res.body;
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
        this.sanctionedGroupService.query().subscribe(
            (res: HttpResponse<ISanctionedGroupMySuffix[]>) => {
                this.sanctionedgroups = res.body;
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
        this.underwriterService.query().subscribe(
            (res: HttpResponse<IUnderwriterMySuffix[]>) => {
                this.underwriters = res.body;
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
        this.insuranceCompanyService.query().subscribe(
            (res: HttpResponse<IInsuranceCompanyMySuffix[]>) => {
                this.insurancecompanies = res.body;
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
    }

    previousState() {
        window.history.back();
    }

    save() {
        this.isSaving = true;
        if (this.country.id !== undefined) {
            this.subscribeToSaveResponse(this.countryService.update(this.country));
        } else {
            this.subscribeToSaveResponse(this.countryService.create(this.country));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<ICountryMySuffix>>) {
        result.subscribe((res: HttpResponse<ICountryMySuffix>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.previousState();
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackRuleById(index: number, item: IRuleMySuffix) {
        return item.id;
    }

    trackSanctionedGroupById(index: number, item: ISanctionedGroupMySuffix) {
        return item.id;
    }

    trackUnderwriterById(index: number, item: IUnderwriterMySuffix) {
        return item.id;
    }

    trackInsuranceCompanyById(index: number, item: IInsuranceCompanyMySuffix) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    }
    get country() {
        return this._country;
    }

    set country(country: ICountryMySuffix) {
        this._country = country;
    }
}
